import React from 'react';
import PropTypes from 'prop-types';
import MapSearch from './map-search';
import LayerControl from './layer-control';
import DimensionSwitch from './dimension-switch';
import BaseMapSwitch from './base-map-switch';
import ItemWrap from './components/item-wrap';
import classname from 'classnames';
import LayerControlPopover from './layer-control-popover';
import ToolBox from './tool-box';
import Loading from './loading';
import Tip from "./tip";

const Tools = props => {
    const {
        style,
        mapSearch = {},
        layerControl = {},
        dimensionSwitch = {},
        baseMapSwitch = {},
        toolbox = {},
        loading = {},
        tip = {},
        children,
    } = props;

    return (
        <>
            <ul className={classname('cs-tools')} style={style}>
                {mapSearch?.show && <MapSearch {...mapSearch} />}

                {dimensionSwitch?.show && <DimensionSwitch {...mapSearch} {...dimensionSwitch} />}

                {baseMapSwitch?.show && <BaseMapSwitch {...mapSearch} />}
                {toolbox?.show && <ToolBox {...toolbox} />}
                {layerControl?.show && (
                    <>
                        {layerControl.type === 'popover' ? (
                            <LayerControlPopover {...layerControl} />
                        ) : (
                            <LayerControl {...layerControl} />
                        )}
                    </>
                )}

                {tip?.show && <Tip {...tip}/>}

                {children}

                {loading?.show && <Loading {...loading}/>}
            </ul>
        </>
    );
};

Tools.Item = ItemWrap;

Tools.propTypes = {
    mapSearch: PropTypes.object,
    toolbox: PropTypes.object,
    dimensionSwitch: PropTypes.object,
    baseMapSwitch: PropTypes.object,
    layerControl: PropTypes.object,
    tip: PropTypes.object,
    loading: PropTypes.object,
    style: PropTypes.object,
    children: PropTypes.node
};

Tools.defaultProps = {
    mapSearch: { show: true },
    toolbox: { show: true },
    dimensionSwitch: { show: false },
    baseMapSwitch: { show: false },
    layerControl: { show: true, showAll: true },
    tip: { show: false },
    loading: { show: false },
};

export default Tools;
